export default "__VITE_ASSET__B_uAxZ6T__"